import { AppBar, Grid } from '@mui/material';
import { FunctionComponent } from 'react';

import { Container } from './BaseLayout.styles';
import BaseLayoutProps from './BaseLayout.types';

const BaseLayout: FunctionComponent<BaseLayoutProps> = (
  props: BaseLayoutProps
): JSX.Element => {
  const { sideMenu, header, main } = props;

  return (
    <Container container>
      <Grid item className="sideMenu">
        {sideMenu}
      </Grid>
      <Grid flexGrow={1} height="100vh" minWidth="0">
        <AppBar className="header" position="sticky">
          {header}
        </AppBar>
        <Grid item className="main" paddingRight={1}>
          {main}
        </Grid>
      </Grid>
    </Container>
  );
};

export default BaseLayout;
